<template>
  <div class="m-overlay" @click.stop="handleClick" />
</template>

<script>
/**
 * A tinted overlay, could be used as a background for modal, side navigation, popups...
 * Place where a background for modal, side navigation, popups needed.
 */
export default {
  name: 'MOverlay',
  emits: ['close'],
  methods: {
    handleClick() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.m-overlay {
  backdrop-filter: blur(5px);
  bottom: 0;
  display: block;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: var(--z-index-modal-overlay);

  &::before {
    background: var(--overlay-background);
    bottom: 0;
    content: '';
    left: 0;
    opacity: 0.95;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
